import React, { useEffect, useState } from 'react';
import { Typography, Box, Chip } from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
import MachineAccordion from './components/MachineAccordion';
import httpCommon from '../../../../http-common';
import { App_Service } from '../../../../redux/app/app.services';
import getErrorMessage, { logout_if_403 } from '../../../../util';

const MachineMatrix = () => {
  const [, setMachines] = useState([]);
  const [categorizedMachines, setCategorizedMachines] = useState({});


  const fetchData = async () => {
    try {
      const response = await httpCommon.get("/v1/qc/machine_availability");
      const result = (await response).data;
      const data = result.machines;

      // Categorize machines based on machine_category
      const categorized = {};
      data.forEach(machine => {
        const category = machine.machine_category;
        machine.status = machine.availability || "Available";
        if (!categorized[category]) {
          categorized[category] = [];
        }
        categorized[category].push(machine);
      });
      console.log({ categorized });
      setCategorizedMachines(categorized);
      setMachines(data.map((d, idx) => {
        return {
          ...d,
          status: d.status || "Available"
        };
      }));
    } catch (error) {
      logout_if_403(error);
      console.log(getErrorMessage(error));
    }
  };
  const toggleStatus = async (category, id, status, remarks) => {
    const newCategorizedMachines = { ...categorizedMachines };
    const newMachines = newCategorizedMachines[category].map(machine => {
      if (machine.machine_id === id) {
        // if (machine.status === "Available") return { ...machine, status: "busy" };
        // if (machine.status === "busy") return { ...machine, status: "breakdown" };
        // if (machine.status === "breakdown") return { ...machine, status: "Available" };
        // console.log({ remarks });
        return {
          ...machine,
          status,
          remarks
        };
      }
      return machine;
    });
    newCategorizedMachines[category] = newMachines;
    const form_data = new FormData();
    form_data.append("machine_id", id);
    form_data.append("availability", status);
    form_data.append("remarks", remarks);
    // if (status === "Breakdown") form_data.append("remarks", remarks);
    await App_Service.patch_machine(form_data);
    fetchData();

    // setCategorizedMachines(newCategorizedMachines);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(() => {
  //   if (machines.length > 0) {
  //     console.log({ machines });
  //   }
  // }, [machines]);


  return (
    <Box>
      <Box className="flex items-center justify-between flex-wrap">
        <Typography variant="h4" gutterBottom align="left">
          Machine Availability Matrix
        </Typography>
        <Box className="flex gap-2 items-center">
          Legend:
          {/* <span style={{ marginLeft: '10px', color: 'green' }}>Available</span> */}
          <Chip label="Available" variant='filled' color='success' />
          <Chip label="In Use" sx={{
            bgcolor: "#ff9800",
            color: "white"
          }} />
          <Chip label="Under Maintenance" sx={{
            bgcolor: "#f44336",
            color: "white"
          }} />
          <Chip label="Under Calibration" sx={{
            bgcolor: "#f44336",
            color: "white"
          }} />
          <Chip label="Breakdown" sx={{
            bgcolor: "#f44336",
            color: "white"
          }} />
          <Chip label="On Hold" sx={{
            bgcolor: "#9e9e9e",
            color: "white"
          }} />
          {/* <Chip label="Breakdown" sx={{ bgColor: "#f44336" }} /> */}
        </Box>
      </Box>

      {/* Render the categorized machines in accordions */}
      {Object.keys(categorizedMachines).map(category => (
        <MachineAccordion
          key={category}
          categorizedMachines={categorizedMachines}
          category={category}
          toggleStatus={toggleStatus}
        />
      ))}
    </Box>
  );
};

export default MachineMatrix;
